"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import { Betslip } from "fansunited-frontend-components";
import { useFansUnitedSDK } from "fansunited-data-layer/client";
import { useTenantSettings } from "@/lib/tenant/TenantSettingsProvider";
import { useLabels, useLocale } from "@/lib/labels/LabelsProvider";
import { checkGeoBlocked } from "@/app/(app)/actions/checkGeoBlocked";
import { mapTenantToBetslipProps } from "./mapTenantToBetslipProps";
import { mapCanvasLabels } from "./mapCanvasLabels";
import { hydrateFromStorage, useBetslipPersistence } from "./persistence";
import { BetslipGeoProvider } from "./BetslipGeoContext";
import { mapLocaleToLibraryLanguage } from "@/features/fu-widgets/language";
const GEO_CACHE_KEY = "fu_betslip_geo";
function useGeoBlocked() {
  const $ = _c(3);
  const [state, setState] = useState(_temp);
  let t0;
  let t1;
  if ($[0] !== state) {
    t0 = () => {
      if (state !== null) {
        return;
      }
      checkGeoBlocked("odds").then(blocked => {
        window.sessionStorage.setItem(GEO_CACHE_KEY, blocked ? "blocked" : "allowed");
        setState(blocked);
      }).catch(() => setState(false));
    };
    t1 = [state];
    $[0] = state;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return state;
}
function _temp() {
  if (typeof window === "undefined") {
    return null;
  }
  const cached = window.sessionStorage.getItem(GEO_CACHE_KEY);
  if (cached === "blocked") {
    return true;
  }
  if (cached === "allowed") {
    return false;
  }
  return null;
}
export function CanvasBetslip(t0) {
  const $ = _c(15);
  const {
    children
  } = t0;
  const settings = useTenantSettings();
  const labels = useLabels();
  const locale = useLocale();
  const geoBlocked = useGeoBlocked();
  const sdk = useFansUnitedSDK();
  const [mounted, setMounted] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMounted(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  const featureEnabled = settings.features.betslip !== "disabled";
  const modeEnabled = (settings.betslip?.mode ?? "disabled") !== "disabled";
  const shouldMount = mounted && featureEnabled && modeEnabled && geoBlocked === false;
  let t3;
  let t4;
  if ($[2] !== shouldMount) {
    t3 = () => {
      if (!shouldMount) {
        return;
      }
      hydrateFromStorage();
    };
    t4 = [shouldMount];
    $[2] = shouldMount;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  useBetslipPersistence();
  const t5 = geoBlocked === true;
  let t6;
  if ($[5] !== labels || $[6] !== locale || $[7] !== sdk || $[8] !== settings || $[9] !== shouldMount) {
    t6 = shouldMount && settings.betslip && sdk && <Betslip sdk={sdk} language={mapLocaleToLibraryLanguage(locale)} labels={mapCanvasLabels(labels, settings.betslip)} {...mapTenantToBetslipProps(settings)} />;
    $[5] = labels;
    $[6] = locale;
    $[7] = sdk;
    $[8] = settings;
    $[9] = shouldMount;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== children || $[12] !== t5 || $[13] !== t6) {
    t7 = <BetslipGeoProvider isGeoBlocked={t5}>{children}{t6}</BetslipGeoProvider>;
    $[11] = children;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}